import * as React from "react";
import {useState} from "react";
import {Box, Button, Collapse, IconButton} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function DebtorAgedDebtsCell({agedDebts, onAgedDebtClick}) {
    const [expanded, setExpanded] = useState(false);

    if (agedDebts.length === 1) {
        const singleAgedDebt = agedDebts[0];
        return (
            <Button onClick={() => onAgedDebtClick(singleAgedDebt)}>
                {singleAgedDebt.label}
            </Button>
        );
    }

    return (
        <Box>
            <IconButton size="small" onClick={() => setExpanded(!expanded)}>
                {expanded ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>
            {agedDebts.length} comprobantes
            <Collapse in={expanded}>
                <Box sx={{paddingLeft: 4}}>
                    {agedDebts.map((agedDebt, agedDebtIndex) => (
                        <Box key={agedDebtIndex}>
                            <Button onClick={() => onAgedDebtClick(agedDebt)}>
                                {agedDebt.label} - {agedDebt.pendingAmount}
                            </Button>
                        </Box>
                    ))}
                </Box>
            </Collapse>
        </Box>
    );
}
